import {
  GET_PAYMENT_PROFILE,
  GET_PAYMENT_PROFILE_SUCCESS,
  GET_PAYMENT_PROFILE_ERROR,
  GET_PAYMENT_PROFILE_LIST,
  GET_PAYMENT_PROFILE_LIST_SUCCESS,
  GET_PAYMENT_PROFILE_LIST_ERROR,
  SAVE_PAYMENT_PROFILE,
  SAVE_PAYMENT_PROFILE_SUCCESS,
  SAVE_PAYMENT_PROFILE_ERROR,
  GET_MONERIS_CHECKOUT_REQUEST_DATA,
  GET_MONERIS_CHECKOUT_REQUEST_DATA_SUCCESS,
  GET_MONERIS_CHECKOUT_REQUEST_DATA_ERROR,
  UPDATE_PAYMENT_METHOD_SELECT_STATE,
  GET_MONERIS_CHECKOUT_RECEIPT,
  GET_MONERIS_CHECKOUT_RECEIPT_SUCCESS,
  GET_MONERIS_CHECKOUT_RECEIPT_ERROR,
  PAY_USING_CREDIT_CARD,
  PAY_USING_CREDIT_CARD_SUCCESS,
  PAY_USING_CREDIT_CARD_ERROR,
  GET_MONERIS_CHECKOUT_PAYMENT_METHODS,
  GET_MONERIS_CHECKOUT_PAYMENT_METHODS_SUCCESS,
  GET_MONERIS_CHECKOUT_PAYMENT_METHODS_ERROR,
  RECORD_PAYMENT,
  RECORD_PAYMENT_SUCCESS,
  RECORD_PAYMENT_ERROR,
  TRASH_PAYMENT_PROFILE,
  TRASH_PAYMENT_PROFILE_SUCCESS,
  TRASH_PAYMENT_PROFILE_ERROR
} from "../actions";

const INIT_STATE = {
  loading: false,
  profileId: null,
  paymentProfileId: null,
  paymentProfileIdForDelete: null,
  paymentProfileIdForEdit: null,
  paymentProfile: null,
  paymentProfileList: null,
  monerisCheckoutRequestData: null,
  monerisCheckoutTicket: null,
  monerisCheckoutReceipt: null,
  isCreditCardSaved: false,
  paymentSuccessInfo: null,
  recordPaymentInfo: null,
  monerisCheckoutPurchasePaymentMethod: null,
  monerisCheckoutCardVerificationPaymentMethod: null,
  getPaymentProfileError: "",
  getPaymentProfileListError: "",
  savePaymentProfileError: "",
  trashPaymentProfileError: "",
  getMonerisCheckoutRequestDataError: "",
  getMonerisCheckoutReceiptError: "",
  getMonerisCheckoutTicketError: "",
  payUsingCreditCardError: "",
  recordPaymentError: "",
  getMonerisCheckoutPaymentMethodsError: "",
  recordPaymentActionInProgress: false,
  isMonerisCheckoutAddCard: false,
  isMonerisCheckoutEditCard: false,
  progressIconCreditCard: false,
  monerisCheckoutReceiptLoading: false,
  isMonerisCheckoutPanelDisplayed: false,
  isDisabledPlaceOrderButton: false,
  isShippingAddressMessageDisplayed: false,
  isCartEmptyMessageDisplayed: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PAYMENT_PROFILE:
      return { ...state, loading: true, getPaymentProfileError: "", profileId: action.payload.profileId, paymentProfile: null };
    case GET_PAYMENT_PROFILE_SUCCESS:
      return { ...state, loading: false, getPaymentProfileError: "", paymentProfile: action.payload.paymentProfile };
    case GET_PAYMENT_PROFILE_ERROR:
      return { ...state, loading: false, getPaymentProfileError: action.payload ? action.payload.message : "" };
    case GET_PAYMENT_PROFILE_LIST:
      return { ...state, loading: true, getPaymentProfileListError: "", paymentProfileList: null };
    case GET_PAYMENT_PROFILE_LIST_SUCCESS:
      return { ...state, loading: false, getPaymentProfileListError: "", paymentProfileList: action.payload.paymentProfileList };
    case GET_PAYMENT_PROFILE_LIST_ERROR:
      return { ...state, loading: false, getPaymentProfileListError: action.payload ? action.payload.message : "" };
    case SAVE_PAYMENT_PROFILE:
      return { ...state, savingPaymentProfile: true, savePaymentProfileError: "", paymentProfile: action.payload.paymentProfile, isCreditCardSaved: false };
    case SAVE_PAYMENT_PROFILE_SUCCESS:
      let updatedPaymentProfileList = [...state.paymentProfileList];
      if (state.isMonerisCheckoutAddCard) {
        updatedPaymentProfileList = [...updatedPaymentProfileList, action.payload.paymentProfile];
      } else {
        const cardIndex = updatedPaymentProfileList.findIndex(ppr => ppr.paymentProfileId === action.payload.paymentProfile.paymentProfileId);
        if (cardIndex !== -1) {
          updatedPaymentProfileList[cardIndex] = action.payload.paymentProfile;
        }
      }
      return { ...state, savingPaymentProfile: false, savePaymentProfileError: "", paymentProfileList: updatedPaymentProfileList, monerisCheckoutReceipt: null, isCreditCardSaved: true, paymentProfileIdForEdit: null };
    case SAVE_PAYMENT_PROFILE_ERROR:
      return { ...state, savingPaymentProfile: false, savePaymentProfileError: action.payload ? action.payload.message : "", isCreditCardSaved: false, paymentProfileIdForEdit: null };
    case GET_MONERIS_CHECKOUT_REQUEST_DATA:
      return { ...state, loading: true, isMonerisCheckoutEditCard: action.payload.isMonerisCheckoutEditCard, isMonerisCheckoutAddCard: action.payload.isMonerisCheckoutAddCard, monerisCheckoutTicket: null, getMonerisCheckoutRequestDataError: "", monerisCheckoutRequestData: null, getMonerisCheckoutReceiptError: "", getMonerisCheckoutTicketError: "", recordPaymentError: "", recordPaymentActionInProgress: false, monerisCheckoutReceipt: null };
    case GET_MONERIS_CHECKOUT_REQUEST_DATA_SUCCESS:
      if (action.payload.monerisCheckoutTicket) {
        const mco = window.monerisCheckoutObj;
        mco.startCheckout(action.payload.monerisCheckoutTicket);
      }
      return { ...state, loading: false, getMonerisCheckoutRequestDataError: "", monerisCheckoutRequestData: action.payload.monerisCheckoutRequestData, monerisCheckoutTicket: action.payload.monerisCheckoutTicket };
    case GET_MONERIS_CHECKOUT_REQUEST_DATA_ERROR:
      return { ...state, loading: false, getMonerisCheckoutRequestDataError: action.payload ? action.payload.message : "" };
    case GET_MONERIS_CHECKOUT_RECEIPT:
      return { ...state, monerisCheckoutReceiptLoading: true, getMonerisCheckoutReceiptError: "", monerisCheckoutReceipt: null };
    case GET_MONERIS_CHECKOUT_RECEIPT_SUCCESS:
      return { ...state, monerisCheckoutReceiptLoading: false, getMonerisCheckoutReceiptError: "", monerisCheckoutReceipt: action.payload.monerisCheckoutReceipt };
    case GET_MONERIS_CHECKOUT_RECEIPT_ERROR:
      return { ...state, monerisCheckoutReceiptLoading: false, getMonerisCheckoutReceiptError: action.payload ? action.payload.message : "" };
    case PAY_USING_CREDIT_CARD:
      return { ...state, loading: true, payUsingCreditCardError: "", paymentSuccessInfo: null, progressIconCreditCard: true };
    case PAY_USING_CREDIT_CARD_SUCCESS:
      return { ...state, loading: false, payUsingCreditCardError: "", paymentSuccessInfo: action.payload.paymentSuccessInfo, progressIconCreditCard: false };
    case PAY_USING_CREDIT_CARD_ERROR:
      return { ...state, loading: false, payUsingCreditCardError: action.payload ? action.payload.message : "", progressIconCreditCard: false };
    case GET_MONERIS_CHECKOUT_PAYMENT_METHODS:
      return { ...state, loading: true, getMonerisCheckoutPaymentMethodsError: "", monerisCheckoutPurchasePaymentMethod: null, monerisCheckoutCardVerificationPaymentMethod: null };
    case GET_MONERIS_CHECKOUT_PAYMENT_METHODS_SUCCESS:
      return { ...state, loading: false, getMonerisCheckoutPaymentMethodsError: "", monerisCheckoutPurchasePaymentMethod: action.payload.monerisCheckoutPurchasePaymentMethod, monerisCheckoutCardVerificationPaymentMethod: action.payload.monerisCheckoutCardVerificationPaymentMethod };
    case GET_MONERIS_CHECKOUT_PAYMENT_METHODS_ERROR:
      return { ...state, loading: false, getMonerisCheckoutPaymentMethodsError: action.payload ? action.payload.message : "" };
    case RECORD_PAYMENT:
      return { ...state, loading: true, recordPaymentError: "", recordPaymentInfo: null, recordPaymentActionInProgress: true };
    case RECORD_PAYMENT_SUCCESS:
      return { ...state, loading: false, recordPaymentError: "", recordPaymentInfo: action.payload.recordPaymentInfo };
    case RECORD_PAYMENT_ERROR:
      return { ...state, loading: false, recordPaymentError: action.payload ? action.payload.message : "" };
    case UPDATE_PAYMENT_METHOD_SELECT_STATE:
      return { ...state, ...action.payload };
    case TRASH_PAYMENT_PROFILE:
      return { ...state, trashPaymentProfileError: "", paymentProfileIdForDelete: action.payload.paymentProfileId };
    case TRASH_PAYMENT_PROFILE_SUCCESS:
      let paymentProfileListUpdated = [...(state.paymentProfileList.filter(ppr => ppr.paymentProfileId !== state.paymentProfileIdForDelete))];
      return { ...state, trashPaymentProfileError: "", paymentProfileList: paymentProfileListUpdated, paymentProfileIdForDelete: null };
    case TRASH_PAYMENT_PROFILE_ERROR:
      return { ...state, trashPaymentProfileError: action.payload ? action.payload.message : "", paymentProfileIdForDelete: null };
    default:
      return { ...state };
  }
};
